export default function () {
  return {
    restrict: 'A',
    link: (scope, el) =>
      el.bind('load', () => objectFitImages(el))
  };
}
